import { Link } from "react-router-dom";
import { Button } from "../components/Button";

export default function Voluntar() {
    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-blue-50 to-amber-50 p-6 flex items-center justify-center">
            <div className="max-w-2xl w-full bg-white/80 backdrop-blur rounded-2xl shadow-xl p-8 space-y-6 text-center">
                <h1 className="text-3xl font-bold text-indigo-700">
                    Devino voluntar
                </h1>

                <p className="text-gray-700 text-lg">
                    Alătură-te echipei Asociației Socrate și contribuie activ la educația
                    tinerilor.
                </p>

                <div className="bg-indigo-50 rounded-xl p-5 text-left space-y-3 text-sm text-gray-700">
                    <div>
                        <h2 className="font-semibold text-indigo-700">Ce presupune?</h2>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Participare la ateliere educaționale</li>
                            <li>Sprijin organizatoric pentru evenimente</li>
                            <li>Activități de mentorat și consiliere</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="font-semibold text-indigo-700">Ce oferim?</h2>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Experiență practică reală</li>
                            <li>Certificat de voluntariat</li>
                            <li>Dezvoltare personală și profesională</li>
                        </ul>
                    </div>
                </div>

                <Button className="w-full text-lg py-4 bg-gradient-to-r from-indigo-600 to-amber-500 text-white shadow-lg hover:scale-[1.02] transition">
                    Înscrie-te ca voluntar
                </Button>

                <Link to="/">
                    <Button variant="outline" className="w-full">
                        Înapoi la pagina principală
                    </Button>
                </Link>
            </div>
        </div>
    );
}
